import React from 'react';
import './StatisticsCard.scss';

function StatisticsCard(props) {
  const {
    data,
    includeShadow = true,
    className = '',
    isFromChart = false,
    currencyCode = 'USD',
  } = props;

  const CurrencySymbol = ({ currencyCode = 'USD', value = '' }) => {
    let formatter = null;

    try {
      formatter = new Intl.NumberFormat(navigator?.language, {
        style: 'currency',
        currency: currencyCode?.length > 0 ? currencyCode : 'USD',
      });
    } catch (exception) {
      // When an error occurs while retrieving the currency symbol, the default symbol shown is USD.
      formatter = new Intl.NumberFormat(navigator?.language, {
        style: 'currency',
        currency: 'USD',
      });
    } finally {
      const parts = formatter?.formatToParts(0);
      const symbol = parts?.find((part) => part?.type === 'currency')?.value || '';

      return <span>{symbol + '' + value}</span>;
    }
  };

  return (
    <div className={`${className} ${includeShadow ? 'box-shadow ' : ''} h-100 custom-card col p-3`}>
      <div className='d-flex justify-content-center align-items-end flex-column'>
        {data?.map((element, index) => {
          return (
            <div className={`d-flex flex-column col-12 px-2 align-items-end`}>
              <div className='value fw-bold col d-flex justify-content-end  mw-80'>
                <span className='text-truncate d-block'>
                  {element?.name === 'Revenue' && !isFromChart ? (
                    <CurrencySymbol currencyCode={currencyCode} value={element?.value} />
                  ) : (
                    element?.value
                  )}
                </span>
              </div>

              <div className='label col text-nowrap text-end'>{element?.name}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default StatisticsCard;
